// import React, { useState, useEffect, useContext } from "react";
// import { useNavigate, useLocation } from 'react-router-dom';
// import axios from "axios";
// import baseURL  from "../../../../Apiurs/Apiurls";
// import { AuthContext } from "../../../../AuthContext/Authcontext";
// import Navbar from '../../../../Shared/ManagerNavbar/Navbar';
// import "./Addleads.css";
// import './../../../../Layout/Collapse/Collapse.css';

// const DynamicForm = () => {
//   const { user } = useContext(AuthContext);
//   const navigate = useNavigate();
//   const location = useLocation();
  
//   const [formData, setFormData] = useState({
//     lead_name: "",
//     business_name: "",
//     lead_source: "",
//     contact_number: "",
//     email: "",
//     whatsapp_number: "",
//     preferred_contact_method: "",
//     manager: "",
//     associate: "",
//     category: "",
//     product: "",
//     quantity: "",
//     description: "",
//   });

//   const [categories, setCategories] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [managers, setManagers] = useState([]);
//   const [associates, setAssociates] = useState([]);
//   const [leadSources] = useState(["Website", "Referral", "Cold Call", "Email Campaign", "Social Media"]);
//   const [contactMethods] = useState(["Phone", "Email", "WhatsApp"]);
//   const [loadingCategories, setLoadingCategories] = useState(false);
//   const [loadingProducts, setLoadingProducts] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [message, setMessage] = useState("");
//   const [collapsed, setCollapsed] = useState(false);
//   const [isEdit, setIsEdit] = useState(false);

//   useEffect(() => {
//     // Check if editing an existing lead
//     if (location.state && location.state.lead) {
//       setIsEdit(true);
//       setFormData(location.state.lead);
//     }

//     // Fetch categories
//     fetchCategories();

//     // Fetch managers
//     fetchManagers();
//   }, []);

//   useEffect(() => {
//     if (formData.category) {
//       fetchProducts(formData.category);
//     } else {
//       setProducts([]);
//       setFormData((prev) => ({ ...prev, product: "" }));
//     }
//   }, [formData.category]);

//   useEffect(() => {
//     if (formData.manager) {
//       fetchAssociates(formData.manager);
//     } else {
//       setAssociates([]);
//       setFormData((prev) => ({ ...prev, associate: "" }));
//     }
//   }, [formData.manager]);

//   const fetchCategories = async () => {
//     setLoadingCategories(true);
//     try {
//       const response = await axios.get(`${baseURL}/api/categories`, {
//         headers: { Authorization: `Bearer ${user.token}` },
//       });
//       // Assuming categories are unique from the products table
//       const uniqueCategories = [...new Set(response.data.map(item => item.category))].map((name, index) => ({
//         id: index + 1,
//         name,
//       }));
//       setCategories(uniqueCategories);
//     } catch (err) {
//       setError("Failed to fetch categories");
//     } finally {
//       setLoadingCategories(false);
//     }
//   };

//   const fetchProducts = async (category) => {
//     setLoadingProducts(true);
//     try {
//       const response = await axios.get(`${baseURL}/api/products?category=${category}`, {
//         headers: { Authorization: `Bearer ${user.token}` },
//       });
//       const formattedProducts = response.data.map(product => ({
//         id: product.id,
//         name: `${product.description} (${product.cat_nr})`,
//       }));
//       setProducts(formattedProducts);
//     } catch (err) {
//       setError("Failed to fetch products");
//     } finally {
//       setLoadingProducts(false);
//     }
//   };

//   const fetchManagers = async () => {
//     try {
//       const response = await axios.get(`${baseURL}/managers`, {
//         headers: { Authorization: `Bearer ${user.token}` },
//       });
//       setManagers(response.data);
//     } catch (err) {
//       setError("Failed to fetch managers");
//     }
//   };

//   const fetchAssociates = async (managerId) => {
//     try {
//       const response = await axios.get(`${baseURL}/associates?manager=${managerId}`, {
//         headers: { Authorization: `Bearer ${user.token}` },
//       });
//       setAssociates(response.data);
//     } catch (err) {
//       setError("Failed to fetch associates");
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e, action) => {
//     e.preventDefault();
//     setLoading(true);
//     setError("");
//     setMessage("");

//     try {
//       const url = isEdit ? `${baseURL}/leads/${formData.id}` : `${baseURL}/leads`;
//       const method = isEdit ? "put" : "post";

//       await axios({
//         method,
//         url,
//         data: formData,
//         headers: { Authorization: `Bearer ${user.token}` },
//       });

//       setMessage(isEdit ? "Lead updated successfully" : "Lead created successfully");

//       if (action === "saveAndClose") {
//         setTimeout(() => navigate(-1), 1000);
//       } else {
//         if (!isEdit) {
//           setFormData({
//             lead_name: "",
//             business_name: "",
//             lead_source: "",
//             contact_number: "",
//             email: "",
//             whatsapp_number: "",
//             preferred_contact_method: "",
//             manager: "",
//             associate: "",
//             category: "",
//             product: "",
//             quantity: "",
//             description: "",
//           });
//           setProducts([]);
//         }
//       }
//     } catch (err) {
//       setError("Failed to save lead");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const renderForm = () => {
//     return (
//       <div className="ManagerAddLeads-form-grid">
//         {/* Lead Name / Contact Person */}
//         <div className="ManagerAddLeads-input-group">
//           <label>Lead Name / Contact Person *</label>
//           <input
//             type="text"
//             name="lead_name"
//             value={formData.lead_name}
//             onChange={handleChange}
//             placeholder="Enter lead/contact name"
//             required
//           />
//         </div>

//         {/* Business Name */}
//         <div className="ManagerAddLeads-input-group">
//           <label>Business Name</label>
//           <input
//             type="text"
//             name="business_name"
//             value={formData.business_name}
//             onChange={handleChange}
//             placeholder="Enter business name"
//           />
//         </div>

//         {/* Lead Source */}
//         <div className="ManagerAddLeads-input-group">
//           <label>Lead Source *</label>
//           <select
//             name="lead_source"
//             value={formData.lead_source}
//             onChange={handleChange}
//             required
//           >
//             <option value="">Select lead source</option>
//             {leadSources.map((source, index) => (
//               <option key={index} value={source}>{source}</option>
//             ))}
//           </select>
//         </div>

//         {/* Contact Number */}
//         <div className="ManagerAddLeads-input-group">
//           <label>Contact Number *</label>
//           <input
//             type="tel"
//             name="contact_number"
//             value={formData.contact_number}
//             onChange={handleChange}
//             placeholder="Enter contact number"
//             required
//             maxLength="15"
//           />
//         </div>

//         {/* Email Address */}
//         <div className="ManagerAddLeads-input-group">
//           <label>Email Address</label>
//           <input
//             type="email"
//             name="email"
//             value={formData.email}
//             onChange={handleChange}
//             placeholder="Enter email address"
//           />
//         </div>

//         {/* WhatsApp Number */}
//         <div className="ManagerAddLeads-input-group">
//           <label>WhatsApp Number</label>
//           <input
//             type="tel"
//             name="whatsapp_number"
//             value={formData.whatsapp_number}
//             onChange={handleChange}
//             placeholder="Enter WhatsApp number"
//             maxLength="15"
//           />
//         </div>

//         {/* Preferred Contact Method */}
//         <div className="ManagerAddLeads-input-group">
//           <label>Preferred Contact Method</label>
//           <select
//             name="preferred_contact_method"
//             value={formData.preferred_contact_method}
//             onChange={handleChange}
//           >
//             <option value="">Select preferred method</option>
//             {contactMethods.map((method, index) => (
//               <option key={index} value={method}>{method}</option>
//             ))}
//           </select>
//         </div>

//         {/* Manager */}
//         <div className="ManagerAddLeads-input-group">
//           <label>Assign Manager</label>
//           <select
//             name="manager"
//             value={formData.manager || ""}
//             onChange={handleChange}
//           >
//             <option value="">Select Manager</option>
//             {managers.map((manager) => (
//               <option key={manager.id} value={manager.id}>
//                 {manager.name}
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* Associate */}
//         <div className="ManagerAddLeads-input-group">
//           <label>Assign Associate</label>
//           <select
//             name="associate"
//             value={formData.associate || ""}
//             onChange={handleChange}
//             disabled={!formData.manager}
//           >
//             <option value="">Select Associate</option>
//             {associates.map((associate) => (
//               <option key={associate.id} value={associate.id}>
//                 {associate.name}
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* Category */}
//         <div className="ManagerAddLeads-input-group">
//           <label>Category</label>
//           <select
//             name="category"
//             value={formData.category}
//             onChange={handleChange}
//             disabled={loadingCategories}
//           >
//             <option value="">Select category</option>
//             {categories.map((category) => (
//               <option key={category.id} value={category.id}>
//                 {category.name}
//               </option>
//             ))}
//           </select>
//           {loadingCategories && <small>Loading categories...</small>}
//         </div>

//         {/* Product */}
//         <div className="ManagerAddLeads-input-group">
//           <label>Product</label>
//           <select
//             name="product"
//             value={formData.product}
//             onChange={handleChange}
//             disabled={!formData.category || loadingProducts}
//           >
//             <option value="">Select product</option>
//             {products.map((product) => (
//               <option key={product.id} value={product.id}>
//                 {product.name}
//               </option>
//             ))}
//           </select>
//           {loadingProducts && <small>Loading products...</small>}
//           {formData.category && products.length === 0 && !loadingProducts && (
//             <small className="text-muted">No products available in this category</small>
//           )}
//         </div>

//         {/* Quantity */}
//         <div className="ManagerAddLeads-input-group">
//           <label>Quantity</label>
//           <input
//             type="number"
//             name="quantity"
//             value={formData.quantity}
//             onChange={handleChange}
//             placeholder="Enter quantity"
//             min="1"
//           />
//         </div>

//         {/* Description */}
//         <div className="ManagerAddLeads-input-group full-width">
//           <label>Description</label>
//           <textarea
//             name="description"
//             value={formData.description}
//             onChange={handleChange}
//             placeholder="Enter any additional details"
//             rows="3"
//           />
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="CollapseContainer">
//       <Navbar onToggleSidebar={setCollapsed} />
//       <div className={`Collapse ${collapsed ? "collapsed" : ""}`}>
//         <div className="ManagerAddLeads-form-container">
//           <h2 className="ManagerAddLeads-form-header">
//             {isEdit ? "Edit Lead" : "Add Lead"}
//           </h2>
//           {error && <div className="alert alert-danger">{error}</div>}
//           {message && <div className="alert alert-success">{message}</div>}
//           <form onSubmit={(e) => handleSubmit(e, "save")} className="ManagerAddLeads-form">
//             {renderForm()}
//             <div className="ManagerAddLeads-form-footer">
//               <button 
//                 className="btn btn-secondary" 
//                 onClick={() => navigate(-1)}
//                 disabled={loading}
//               >
//                 Back
//               </button>
//               <button 
//                 className="btn btn-primary" 
//                 type="submit" 
//                 disabled={loading}
//               >
//                 {loading ? (isEdit ? "Updating..." : "Saving...") : (isEdit ? "Update" : "Save")}
//               </button>
//               <button
//                 className="btn btn-success"
//                 type="button"
//                 disabled={loading}
//                 onClick={(e) => handleSubmit(e, "saveAndClose")}
//               >
//                 {loading ? (isEdit ? "Updating..." : "Saving...") : (isEdit ? "Update & Close" : "Save & Close")}
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DynamicForm;

import React, { useState, useEffect, useMemo, useContext } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import axios from "axios";
import { AuthContext } from "../../../../AuthContext/Authcontext";
import Navbar from '../../../../Shared/ManagerNavbar/Navbar';
import "./Addleads.css";
import './../../../../Layout/Collapse/Collapse.css';
import baseURL from "../../../../Apiurs/Apiurls";

const M_DynamicForm = () => {
 // Replace with your actual baseURL
  // const { user } = React.useContext(AuthContext);
 const { userId } = useContext(AuthContext);
 console.log("Logged in user ID:", userId);
  const navigate = useNavigate();
  const location = useLocation();

  const [formData, setFormData] = useState({
    lead_name: "",
    business_name: "",
    lead_source: "",
    contact_number: "",
    email: "",
    whatsapp_number: "",
    preferred_contact_method: "",
    terms_conditions: "",
  });

  const [mainCategories, setMainCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedMainCategory, setSelectedMainCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [selectedProductId, setSelectedProductId] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [leadSources] = useState(["Website", "Referral", "Cold Call", "Email Campaign", "Social Media"]);
  const [contactMethods] = useState(["Phone", "Email", "WhatsApp"]);
  const [loadingMainCategories, setLoadingMainCategories] = useState(false);
  const [loadingSubCategories, setLoadingSubCategories] = useState(false);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [collapsed, setCollapsed] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    if (location.state && location.state.lead) {
      setIsEdit(true);
      setFormData(location.state.lead);
      if (location.state.lead.products) {
        setSelectedProducts(location.state.lead.products);
      }
    }
    fetchMainCategories();
  }, []);

  useEffect(() => {
    if (selectedMainCategory) {
      fetchSubCategories(selectedMainCategory);
    } else {
      setSubCategories([]);
      setProducts([]);
      setSelectedSubCategory("");
      setSelectedProductId("");
    }
  }, [selectedMainCategory]);

  useEffect(() => {
    if (selectedSubCategory) {
      fetchProducts(selectedSubCategory);
    } else {
      setProducts([]);
      setSelectedProductId("");
    }
  }, [selectedSubCategory]);

  const fetchMainCategories = async () => {
    setLoadingMainCategories(true);
    try {
      const response = await axios.get(`${baseURL}/api/main-categories`);
      setMainCategories(response.data);
    } catch (err) {
      setError("Failed to fetch main categories");
    } finally {
      setLoadingMainCategories(false);
    }
  };

  const fetchSubCategories = async (mainCategoryId) => {
    setLoadingSubCategories(true);
    try {
      const response = await axios.get(`${baseURL}/api/sub-categories/${mainCategoryId}`);
      setSubCategories(response.data);
    } catch (err) {
      setError("Failed to fetch sub-categories");
    } finally {
      setLoadingSubCategories(false);
    }
  };

  const fetchProducts = async (subCategoryId) => {
    setLoadingProducts(true);
    try {
      const response = await axios.get(`${baseURL}/api/products/${subCategoryId}`);
      setProducts(response.data);
    } catch (err) {
      setError("Failed to fetch products");
    } finally {
      setLoadingProducts(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const selectedProduct = useMemo(() => {
    if (!selectedProductId) return null;
    return products.find((p) => String(p.detail_id) === String(selectedProductId)) || null;
  }, [selectedProductId, products]);

  const addProduct = () => {
    setError("");
    if (!selectedProduct) {
      setError("Please select a product.");
      return;
    }
    const qtyNum = Math.max(1, parseInt(quantity || 1, 10));
    const mainCategory = mainCategories.find((mc) => String(mc.id) === String(selectedMainCategory));
    const subCategory = subCategories.find((sc) => String(sc.id) === String(selectedSubCategory));
    
    setSelectedProducts((prev) => {
      const idx = prev.findIndex((x) => String(x.detail_id) === String(selectedProduct.detail_id));
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + qtyNum };
        return copy;
      }
      return [
        ...prev,
        {
          ...selectedProduct,
          quantity: qtyNum,
          maincategory_name: mainCategory ? mainCategory.maincategory_name : "",
          subcategory_name: subCategory ? subCategory.subcategory_name : "",
        },
      ];
    });
    setSelectedProductId("");
    setQuantity(1);
  };

  const updateProductQty = (detail_id, newQty) => {
    const qtyNum = Math.max(1, parseInt(newQty || 1, 10));
    setSelectedProducts((prev) =>
      prev.map((item) =>
        String(item.detail_id) === String(detail_id) ? { ...item, quantity: qtyNum } : item
      )
    );
  };

  const removeProduct = (detail_id) => {
    setSelectedProducts((prev) => prev.filter((item) => String(item.detail_id) !== String(detail_id)));
  };

 const handleSubmit = async (e, action) => {
  e.preventDefault();
  setLoading(true);
  setError("");
  setMessage("");

  try {
    const leadData = {
      ...formData,
      products: selectedProducts,
      user_id: userId,   // 👈 Manager's ID from auth context / localStorage
    };

    const url = isEdit 
      ? `${baseURL}/api/leads/${formData.id}` 
      : `${baseURL}/api/newleads/manager`;   // 👈 use the new endpoint for manager

    const method = isEdit ? "put" : "post";

    await axios({ method, url, data: leadData });

    setMessage(isEdit ? "Lead updated successfully" : "Lead created successfully");

    if (action === "saveAndClose") {
      setTimeout(() => navigate(-1), 1000);
    } else {
      if (!isEdit) {
        setFormData({
          lead_name: "",
          business_name: "",
          lead_source: "",
          contact_number: "",
          email: "",
          whatsapp_number: "",
          preferred_contact_method: "",
          terms_conditions: "",
        });
        setSelectedProducts([]);
        setSelectedMainCategory("");
        setSelectedSubCategory("");
        setSelectedProductId("");
        setQuantity(1);
      }
    }
  } catch (err) {
    setError("Failed to save lead");
  } finally {
    setLoading(false);
  }
};


  const currency = (n) => {
    const num = Number(n || 0);
    return num.toLocaleString("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 2 });
  };

  const renderGeneralDetails = () => (
    <div className="AdminAddLeads-form-grid">
      <div className="AdminAddLeads-input-group">
        <label>Lead Name / Contact Person *</label>
        <input
          type="text"
          name="lead_name"
          value={formData.lead_name}
          onChange={handleChange}
          placeholder="Enter lead/contact name"
          required
        />
      </div>
      <div className="AdminAddLeads-input-group">
        <label>Business Name</label>
        <input
          type="text"
          name="business_name"
          value={formData.business_name}
          onChange={handleChange}
          placeholder="Enter business name"
        />
      </div>
      <div className="AdminAddLeads-input-group">
        <label>Lead Source *</label>
        <select
          name="lead_source"
          value={formData.lead_source}
          onChange={handleChange}
          required
        >
          <option value="">Select lead source</option>
          {leadSources.map((source, index) => (
            <option key={index} value={source}>{source}</option>
          ))}
        </select>
      </div>
      <div className="AdminAddLeads-input-group">
        <label>Contact Number *</label>
        <input
          type="tel"
          name="contact_number"
          value={formData.contact_number}
          onChange={handleChange}
          placeholder="Enter contact number"
          required
          maxLength="15"
        />
      </div>
      <div className="AdminAddLeads-input-group">
        <label>Email Address</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Enter email address"
        />
      </div>
      <div className="AdminAddLeads-input-group">
        <label>WhatsApp Number</label>
        <input
          type="tel"
          name="whatsapp_number"
          value={formData.whatsapp_number}
          onChange={handleChange}
          placeholder="Enter WhatsApp number"
          maxLength="15"
        />
      </div>
      <div className="AdminAddLeads-input-group">
        <label>Preferred Contact Method</label>
        <select
          name="preferred_contact_method"
          value={formData.preferred_contact_method}
          onChange={handleChange}
        >
          <option value="">Select preferred method</option>
          {contactMethods.map((method, index) => (
            <option key={index} value={method}>{method}</option>
          ))}
        </select>
      </div>
      <div className="AdminAddLeads-input-group full-width">
        <label>Terms and Conditions</label>
        <textarea
          name="terms_conditions"
          value={formData.terms_conditions}
          onChange={handleChange}
          placeholder="Enter terms and conditions"
          rows="3"
        />
      </div>
    </div>
  );

  const renderProductSelection = () => (
    <div className="card shadow-sm mb-3">
      <div className="card-body">
        <h5 className="mb-3">Add Products</h5>
        <div className="row g-3 align-items-end">
          <div className="col-md-3">
            <label className="form-label">Main Category</label>
            <select
              className="form-select"
              value={selectedMainCategory}
              onChange={(e) => setSelectedMainCategory(e.target.value)}
            >
              <option value="">-- Select --</option>
              {mainCategories.map((mc) => (
                <option key={mc.id} value={mc.id}>
                  {mc.maincategory_name}
                </option>
              ))}
            </select>
            {loadingMainCategories && <small className="text-muted">Loading…</small>}
          </div>
          <div className="col-md-4">
            <label className="form-label">Sub Category</label>
            <select
              className="form-select"
              value={selectedSubCategory}
              onChange={(e) => setSelectedSubCategory(e.target.value)}
              disabled={!selectedMainCategory}
            >
              <option value="">-- Select --</option>
              {subCategories.map((sc) => (
                <option key={sc.id} value={sc.id}>
                  {sc.subcategory_name}
                </option>
              ))}
            </select>
            {loadingSubCategories && <small className="text-muted">Loading…</small>}
          </div>
          <div className="col-md-5">
            <label className="form-label">Product (Name • Model • Size • Price)</label>
            <select
              className="form-select"
              value={selectedProductId}
              onChange={(e) => setSelectedProductId(e.target.value)}
              disabled={!selectedSubCategory || !products.length}
            >
              <option value="">-- Select --</option>
              {products.map((p) => (
                <option key={p.detail_id} value={p.detail_id}>
                  {p.product_name} • {p.batch} • {p.size || "-"} • {currency(p.listprice)}
                </option>
              ))}
            </select>
            {loadingProducts && <small className="text-muted">Loading…</small>}
          </div>
          <div className="col-md-2">
            <label className="form-label">Quantity</label>
            <input
              type="number"
              className="form-control"
              min={1}
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
              disabled={!selectedProductId}
            />
          </div>
          <div className="col-md-2 d-grid">
            <button className="btn btn-primary" onClick={addProduct} disabled={!selectedProductId}>
              Add to List
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  const renderProductTable = () => (
    <div className="card shadow-sm">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h5 className="m-0">Selected Products</h5>
          <small className="text-muted">{selectedProducts.length} item(s)</small>
        </div>
        <div className="table-responsive">
          <table className="table table-sm table-bordered align-middle">
            <thead className="table-light">
              <tr>
                <th style={{ minWidth: 220 }}>Product</th>
                <th>Model</th>
                <th>Size</th>
                <th className="text-end">Price</th>
                <th style={{ width: 120 }}>Qty</th>
                <th className="text-end">GST %</th>
                <th className="text-end">Line Total</th>
                <th style={{ width: 60 }}></th>
              </tr>
            </thead>
            <tbody>
              {selectedProducts.length === 0 ? (
                <tr>
                  <td colSpan="8" className="text-center text-muted py-4">
                    No products added yet.
                  </td>
                </tr>
              ) : (
                selectedProducts.map((item) => {
                  const price = Number(item.listprice || 0);
                  const qty = Number(item.quantity || 0);
                  const line = price * qty;
                  const gstPct = Number(item.gstrate || 0);
                  return (
                    <tr key={item.detail_id}>
                      <td>
                        <div className="fw-semibold">{item.product_name}</div>
                        {item.description ? <small className="text-muted">{item.description}</small> : null}
                      </td>
                      <td>{item.batch}</td>
                      <td>{item.size || "-"}</td>
                      <td className="text-end">{currency(price)}</td>
                      <td>
                        <input
                          type="number"
                          min={1}
                          className="form-control form-control-sm"
                          value={qty}
                          onChange={(e) => updateProductQty(item.detail_id, e.target.value)}
                        />
                      </td>
                      <td className="text-end">{gstPct}%</td>
                      <td className="text-end">{currency(line)}</td>
                      <td className="text-center">
                        <button
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => removeProduct(item.detail_id)}
                        >
                          ✕
                        </button>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  return (
    <div className="CollapseContainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`Collapse ${collapsed ? "collapsed" : ""}`}>
        <div className="AdminAddLeads-form-container">
          <h2 className="AdminAddLeads-form-header">
            {isEdit ? "Edit Lead" : "Add Lead"}
          </h2>
          {error && <div className="alert alert-danger">{error}</div>}
          {message && <div className="alert alert-success">{message}</div>}
          <form onSubmit={(e) => handleSubmit(e, "save")} className="AdminAddLeads-form">
            {renderGeneralDetails()}
            {renderProductSelection()}
            {renderProductTable()}
            <div className="AdminAddLeads-form-footer">
              <button
                className="btn btn-secondary"
                onClick={() => navigate(-1)}
                disabled={loading}
              >
                Back
              </button>
              <button className="btn btn-primary" type="submit" disabled={loading}>
                {loading ? (isEdit ? "Updating..." : "Saving...") : (isEdit ? "Update" : "Save")}
              </button>
              <button
                className="btn btn-success"
                type="button"
                disabled={loading}
                onClick={(e) => handleSubmit(e, "saveAndClose")}
              >
                {loading ? (isEdit ? "Updating..." : "Saving...") : (isEdit ? "Update & Close" : "Save & Close")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default M_DynamicForm;